import type { WaitlistedVariantIds } from '~/types/api/bff/web/waitlist/waitlist.types'
import type { WishlistedVariantIds } from '~/types/api/bff/web/wishlist/wishlist.types'

/* To update localStorage values as these are used by web-ui & luxola as a first cache hit.
 * Not relying on localStorage values for SWA because user may have multiple devices and these values will won't get updated or invalidated.
 * Better to fetch from server once per session
 */

const updateLocalstorage = (
  key: string,
  data: WaitlistedVariantIds | WishlistedVariantIds
) =>
  import.meta.client &&
  window.localStorage.setItem(
    key,
    JSON.stringify(data.map(variantId => Number(variantId)))
  )

export const updateLocalStorageWaitlistedIds = (
  waitlistedIds: WaitlistedVariantIds
) => updateLocalstorage('waitlistedVariants', waitlistedIds)

export const updateLocalStorageWishlistedIds = (
  wishlistedIds: WishlistedVariantIds
) => updateLocalstorage('wishlistedVariants', wishlistedIds)
